import React, { useEffect, useState } from 'react';

import { Formik, Form, Field } from 'formik';
import { Form as BootstrapForm } from 'react-bootstrap';
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import { Textfield, NextButton, ErrorMessage, Label, LoginTitle } from './styles';

import api from '~/services/api';
import recover from '~/assets/images/recover_icon.svg';

import * as Yup from 'yup';

function Document() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const EmailSchema = Yup.object().shape({
    email: Yup.string().required('Preencha o seu E-mail'),
  });

  function handleEmail(e, handleChange) {
    const event = e;
    return handleChange(event);
  }
  const history = useHistory();


  async function handleSubmit(values) {
    const header = {
      'Content-Type': 'application/json',
      'Accept-Language': 'pt-BR',
       Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
       client_id: process.env.REACT_APP_CLIENT_ID,
    };

    const parameters = {
      method: 'POST',
      headers: header,
    };

    const body = {
      grant_type: "reset_password",
      username: values.email,
      url: `${window.location.origin}/criar-senha`
    };

    try {
      const res = await api.post('residential/store/v1/users/authentications', body, parameters)
      if(res){
        localStorage.setItem('email', values.email);

        const resetPasswordToken = res.headers['x-reset-password-token'];
        if (resetPasswordToken) {
          localStorage.setItem('reset_password_token', resetPasswordToken);

          try {
            const resetPasswordInfoHeader = {
              'Content-Type': 'application/json',
              'Accept-Language': 'pt-BR',
              'X-Reset-Password-Token': resetPasswordToken,
              'client_id': process.env.REACT_APP_CLIENT_ID,
            };

            const resetPasswordInfoParams = {
              method: 'POST',
              headers: resetPasswordInfoHeader,
            };

            const resetPasswordInfoBody = {
              email: values.email
            };

            const resetPasswordInfoRes = await api.post(
              'residential/store/v1/users/reset-password-info',
              resetPasswordInfoBody,
              resetPasswordInfoParams
            );

            if (resetPasswordInfoRes && resetPasswordInfoRes.data) {
              localStorage.setItem('resetPasswordContacts', JSON.stringify(resetPasswordInfoRes.data.contacts));
              localStorage.setItem('userId', resetPasswordInfoRes.data.userId);
              setLoading(false);
              dispatch({ type: "SET_STEP", step: 20 });
            } else {
              setLoading(false);
              dispatch({ type: "SET_STEP", step: 60 });
            }
          } catch (error) {
            setLoading(false);
            dispatch({ type: "SET_STEP", step: 60 });
          }
        } else {
          setLoading(false);
          dispatch({ type: "SET_STEP", step: 60 });
        }
      } else {
        setLoading(false);
      }
     } catch (error) {
      setLoading(false);
      dispatch({ type: "SET_STEP", step: 60 });
    }

  }

  useEffect(()=>{
    window.addEventListener('popstate', function() {
      dispatch({ type: "SET_STEP", step: 0 });
      history.push('/acessar')
    });
  },[])

  return (
    <>
      <LoginTitle className="mb-3">Recuperar ou alterar senha</LoginTitle>
      <Formik
        initialValues={{ email: '' }}
        onSubmit={values => {
          setLoading(true);
          handleSubmit(values);
        }}
        validationSchema={EmailSchema}
      >
        {({ handleChange, handleBlur, values, errors, touched }) => (
          <Form style={{ width: '100%' }} autocomplete="off">
            <BootstrapForm.Group controlId="email">
              <Label>Seu e-mail</Label>
              <Field
                render={() => {
                  return (
                    <Textfield
                      id="email"
                      type="text"
                      label="Código do Cliente"
                      arial-label="Código do Cliente"
                      aria-required
                      errorCondition={errors.email && touched.email}
                      errorMessage={errors.email}
                      title="Código do Cliente"
                      onBlur={handleBlur}
                      placeholder="E-mail"
                      value={values.email}
                      onChange={e => handleEmail(e, handleChange)}
                    />
                  );
                }}
                name="email"
              />
              {errors.email && touched.email ? (
                <ErrorMessage>{errors.email}</ErrorMessage>
              ) : null}
            </BootstrapForm.Group>
            <NextButton type="submit" disabled={loading}>
              {loading ? (
                <i
                  className="fa fa-spinner fa-pulse fa-3x fa-fw"
                  style={{ fontSize: '1.3rem' }}
                />
              ) : (
                <>
                  <img src={recover} alt="Ícone de login" />
                  <span style={{ paddingLeft: '1rem' }}>Recuperar/alterar senha</span>
                </>
              )}
            </NextButton>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default Document;
